import {
  BestPerformingBrandsEntity,
  BestPerformingLocationsEntity,
  BestPerformingProviderEntity,
  BestPerformingStateEntity,
  Disclaimer,
  displayCentsInDollars,
  Div,
  formatNumber,
  Img,
  lightTheme,
  noImage,
  P,
  renderProviderIcon,
  renderProviderName,
} from '@vgrubs/components';

export const BestPerformingPlaceholder = ({ length }: { length: number }) => {
  return (
    length < 1 && (
      <Div
        key={`placeholder`}
        $flex
        $center
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          pointerEvents: 'none',
        }}
      >
        {length === 0 && (
          <P $center $m="0" $width="100%">
            No data available.
          </P>
        )}
      </Div>
    )
  );
};

export const BestPerformingLocationComponent = ({
  item,
  index,
}: {
  item: BestPerformingLocationsEntity;
  index: number;
}) => {
  return (
    <Div
      $flex
      $alignCenter
      $between
      $borderBottom
      $borderColor={lightTheme.lightGray}
      $height="70px"
      $heightSM="70px"
      $gap="12px"
    >
      <Div>
        <P
          $bold
          $mb="4"
          $left
          $lineHeight="1.2"
          $pointer
          $hoverUnderline
          onClick={() => window.open(`/locations/${item.id}`, '_blank')}
        >
          {index + 1}. {item.name}
        </P>
        <Disclaimer $m="0" $left>
          Total Sales:{' '}
          <span style={{ color: lightTheme.green }}>
            {displayCentsInDollars(item.totalSales)}
          </span>
        </Disclaimer>
      </Div>
      <P $bold $m="0" $color={lightTheme.green}>
        {formatNumber(item.totalOrders)}
      </P>
    </Div>
  );
};

export const BestPerformingStateComponent = ({
  item,
  index,
}: {
  item: BestPerformingStateEntity;
  index: number;
}) => (
  <Div
    $flex
    $alignCenter
    $between
    $borderBottom
    $borderColor={lightTheme.lightGray}
    $height="70px"
    $heightSM="70px"
  >
    <Div>
      <P $bold $mb="4" $lineHeight="1.2">
        {index + 1}. {item.state}
      </P>
      <Disclaimer $m="0">
        Total Sales:{' '}
        <span style={{ color: lightTheme.green }}>
          {displayCentsInDollars(item.totalSales)}
        </span>
      </Disclaimer>
    </Div>
    <P $bold $m="0" $color={lightTheme.green}>
      {formatNumber(item.totalOrders)}
    </P>
  </Div>
);

export const BestPerformingBrandComponent = ({
  item,
  index,
}: {
  item: BestPerformingBrandsEntity;
  index: number;
}) => {
  const isBrandTemplate = item.id.includes('bt-');

  const handleClick = () => {
    if (isBrandTemplate) {
      return;
    } else {
      window.open(`/brand/${item.id.replace('b-', '')}`, '_blank');
    }
  };

  return (
    <Div
      $flex
      $alignCenter
      key={index}
      $borderBottom
      $borderColor={lightTheme.lightGray}
      $height="70px"
      $heightSM="70px"
      $gap="12px"
      $gapSM="12px"
    >
      <Div $flexNone>
        <Img
          alt=""
          src={item.imageUrl || noImage}
          $width="40px"
          $widthSM="40px"
          $height="40px"
          $heightSM="40px"
          $borderRadius="1000px"
        />
      </Div>
      <Div $flex $alignCenter $gap="20px" $width="100%" $between>
        <Div $flex $center $gap="20px">
          <Div>
            <P
              $bold
              $mb="4"
              $lineHeight="1.2"
              $pointer={!isBrandTemplate}
              $hoverUnderline={!isBrandTemplate}
              onClick={handleClick}
            >
              {index + 1}. {item.name}
            </P>
            <Disclaimer $m="0">
              Total Sales:{' '}
              <span style={{ color: lightTheme.green }}>
                {displayCentsInDollars(item.totalSales)}
              </span>
            </Disclaimer>
          </Div>
        </Div>

        <P $bold $m="0" $color={lightTheme.green}>
          {formatNumber(item.totalOrders)}
        </P>
      </Div>
    </Div>
  );
};

export const BestPerformingProviderComponent = ({
  item,
  index,
}: {
  item: BestPerformingProviderEntity;
  index: number;
}) => (
  <Div
    $flex
    $alignCenter
    key={index}
    $borderBottom
    $borderColor={lightTheme.lightGray}
    $height="70px"
    $heightSM="70px"
    $gap="12px"
    $gapSM="12px"
  >
    <Div $flexNone>
      <Img
        alt=""
        src={renderProviderIcon(item.provider)}
        $width="40px"
        $widthSM="40px"
      />
    </Div>
    <Div $flex $alignCenter $gap="20px" $width="100%" $between>
      <Div $flex $center $gap="20px">
        <Div>
          <P $bold $mb="4" $lineHeight="1.2">
            {index + 1}. {renderProviderName(item.provider)}
          </P>
          <Disclaimer $m="0">
            Total Sales:{' '}
            <span style={{ color: lightTheme.green }}>
              {displayCentsInDollars(item.totalSales)}
            </span>
          </Disclaimer>
        </Div>
      </Div>

      <P $bold $m="0" $color={lightTheme.green}>
        {formatNumber(item.totalOrders)}
      </P>
    </Div>
  </Div>
);
